const actions = {
  SEARCH_CLIENT_APP_KEYS: 'SEARCH_CLIENT_APP_KEYS',
  SEARCH_CLIENT_APP_KEYS_ENDED: 'SEARCH_CLIENT_APP_KEYS_ENDED',
  CREATE_CLIENT_APP_KEY: 'CREATE_CLIENT_APP_KEY',
  CREATE_CLIENT_APP_KEY_ENDED: 'CREATE_CLIENT_APP_KEY_ENDED',
  UPDATE_CLIENT_APP_KEY: 'UPDATE_CLIENT_APP_KEY',
  UPDATE_CLIENT_APP_KEY_ENDED: 'UPDATE_CLIENT_APP_KEY_ENDED',
  UPDATE_CLIENT_APP_KEY_ENABLE: 'UPDATE_CLIENT_APP_KEY_ENABLE',
  UPDATE_CLIENT_APP_KEY_ENABLE_ENDED: 'UPDATE_CLIENT_APP_KEY_ENABLE_ENDED',
};
export default actions;
